import { get, post, patch } from 'aws-amplify/api';

// aws-amplify v6 REST calls resolve to an operation whose `.response` promise carries
// the parsed body accessors, instead of resolving directly with the JSON body like v5/v4 did.
async function unwrapResponse(operation) {
    const { body } = await operation.response;
    return body.json();
}

export function apiGet(apiName, path, options) {
    return unwrapResponse(get({ apiName, path, options }));
}

export function apiPost(apiName, path, options) {
    return unwrapResponse(post({ apiName, path, options }));
}

export function apiPatch(apiName, path, options) {
    return unwrapResponse(patch({ apiName, path, options }));
}
